import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useLocaleContext } from '../context/LocaleContext';
import { addLocale, replace } from '../misc';

const PublicRoute = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const token = localStorage.accessToken;
  let redirectUrl = '/';

  const locale = useLocaleContext();
  const addLocaleToUrl = addLocale(locale);

  // This code will only run when route is /login
  if (history.location.pathname === addLocaleToUrl('/login')) {
    const queryData = new URLSearchParams(history.location.search);
    const url = decodeURIComponent(queryData.get('url') || '');

    if (url && url.length > 0) {
      try {
        const urlObj = JSON.parse(JSON.parse(url).url);
        redirectUrl = addLocaleToUrl(
          `/${replace(urlObj.name)}/${replace(urlObj.formField.name)}/`
        );
      } catch (err) {
        // eslint-ignore-no-empty
      }
    }
  }

  return (
    <Route
      {...rest}
      render={props =>
        token ? <Redirect to={redirectUrl} /> : <Component {...props} />
      }
    />
  );
};

PublicRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
};

export default PublicRoute;
